const styles = () => ({
  cell: {
    textAlign: 'left'
  },
  spinner: {
    fontSize: '20px'
  },
  pendingAddition: {
    opacity: '.5',
    pointerEvents: 'none'
  }
})

export default styles
